export default __webpack_public_path__ + "static/media/master-data.1f1c8748.svg";